export const formatCOP = (n) =>
  new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(
    Number(n || 0)
  );

export const formatKm = (n) => `${Number(n || 0).toFixed(2)} km`;

export const formatDateTime = (s) =>
  s ? new Date(s).toLocaleString("es-CO", { dateStyle: "medium", timeStyle: "short" }) : "—";

export const VEHICLE_LABELS = {
  MOTORCYCLE: "Motocicleta",
  CAR: "Automóvil",
  PICKUP: "Camioneta (Pickup)",
  VAN: "Van",
  TRUCK: "Camión",
};

// Categorías de carga (códigos alineados con el backend en create_service)
export const CARGO_CATEGORIES = [
  { value: "FOOD", label: "Comida" },
  { value: "PACKAGES", label: "Paquetes" },
  { value: "DOCUMENTS", label: "Documentos" },
  { value: "PARTS", label: "Repuestos" },
  { value: "GOODS", label: "Productos/Mercancía" },
];
export const CARGO_CATEGORY_LABELS = CARGO_CATEGORIES.reduce((a, c) => ((a[c.value] = c.label), a), {});

export const STATUS_META = {
  REQUESTED: { label: "Solicitado", color: "#A78BFA", bg: "rgba(139,92,246,0.14)", border: "#8B5CF6" },
  SEARCHING_DRIVER: { label: "Buscando Conductor", color: "#FBBF24", bg: "rgba(245,158,11,0.14)", border: "#F59E0B" },
  ACCEPTED: { label: "Aceptado", color: "#60A5FA", bg: "rgba(59,130,246,0.14)", border: "#3B82F6" },
  DRIVER_GOING_TO_PICKUP: { label: "Camino a Recogida", color: "#93C5FD", bg: "rgba(59,130,246,0.14)", border: "#3B82F6" },
  DRIVER_ARRIVED_PICKUP: { label: "En Punto de Recogida", color: "#34D399", bg: "rgba(16,185,129,0.14)", border: "#10B981" },
  PICKED_UP: { label: "Paquete Recogido", color: "#FF8533", bg: "rgba(255,106,0,0.14)", border: "#FF6A00" },
  IN_TRANSIT: { label: "En Tránsito", color: "#FF6A00", bg: "rgba(255,106,0,0.20)", border: "#FF6A00" },
  DRIVER_ARRIVED_DESTINATION: { label: "En Destino", color: "#34D399", bg: "rgba(16,185,129,0.14)", border: "#10B981" },
  DELIVERED: { label: "Entregado", color: "#10B981", bg: "rgba(16,185,129,0.20)", border: "#10B981" },
  CANCELLED: { label: "Cancelado", color: "#F87171", bg: "rgba(239,68,68,0.14)", border: "#EF4444" },
  INCIDENT: { label: "Novedad / Incidencia", color: "#EF4444", bg: "rgba(220,38,38,0.20)", border: "#DC2626" },
};

// Main driver flow used by the timeline (ordered)
export const FLOW_STEPS = [
  "SEARCHING_DRIVER",
  "ACCEPTED",
  "DRIVER_GOING_TO_PICKUP",
  "DRIVER_ARRIVED_PICKUP",
  "PICKED_UP",
  "IN_TRANSIT",
  "DRIVER_ARRIVED_DESTINATION",
  "DELIVERED",
];

export const roleHome = (role) =>
  role === "ADMIN" ? "/admin" : role === "DRIVER" ? "/driver" : "/business";
